import React from 'react'
import { Text, View } from 'react-native'

import { quote } from '@ui-kit/components/Quote/styles'

const Quote = (props: { children: React.ReactNode }) => {
  const { wrapper, text } = quote()
  return (
    <View className={wrapper()}>
      <Text className={text()}>{props.children}</Text>
    </View>
  )
}

export default Quote
